<template>
  <BaseCard title="Tambah Retur">
    <template #action>
      <BaseBadge color="yellow">Draft</BaseBadge>
    </template>

    <div class="grid grid-cols-2 gap-4">
      <BaseInput
        class="col-span-2"
        label="Tanggal"
        inset
        disabled
        :value="retur.date | formatDate('MM/DD/YYYY')"
      />
      <SearchOfficeInput
        :office-type="officeType"
        :disabled="disabled || disabledOffice"
        with-current-warehouse
        with-area
        v-model="retur.office"
      />
      <BaseInput
        :label="`Nama ${officeTypeLabel}`"
        inset
        disabled
        :placeholder="`Nama ${officeTypeLabel}`"
        :value="retur.office.name"
      />
      <BaseInput
        label="Kode Gudang"
        inset
        disabled
        placeholder="Kode Gudang"
        :value="retur.office.currentWarehouse.code"
      />
      <BaseInput
        label="Wilayah Harga"
        inset
        disabled
        placeholder="Wilayah Harga"
        :value="retur.office.area.code"
      />
      <BaseInput class="col-span-2" label="Metode Pengiriman">
        <div class="flex gap-8">
          <BaseRadio
            val="pickup"
            label="Diambil"
            :disabled="disabled"
            v-model="retur.shipmentType"
          />
          <BaseRadio
            val="delivery"
            label="Dikirim"
            :disabled="disabled"
            v-model="retur.shipmentType"
          />
        </div>
      </BaseInput>
      <BaseInput class="col-span-2" label="Metode Retur">
        <div class="flex gap-8">
          <BaseRadio
            :val="true"
            label="Normal (default)"
            :disabled="disabled"
            v-model="retur.usingStock"
          />
          <BaseRadio
            :val="false"
            label="Tanpa Barang"
            :disabled="disabled"
            v-model="retur.usingStock"
          />
        </div>
      </BaseInput>
      <BaseInput class="col-span-2" label="Tipe Barang Retur">
        <div class="flex gap-8">
          <BaseRadio
            val="stock"
            label="Barang dari Stock"
            :disabled="disabled"
            v-model="retur.returSource"
          />
          <BaseRadio
            val="order_detail"
            label="Barang dari Faktur"
            :disabled="disabled"
            v-model="retur.returSource"
          />
        </div>
      </BaseInput>
    </div>
  </BaseCard>
</template>

<script>
import BaseRadio from '../base/BaseRadio.vue';
import SearchOfficeInput from '../office/search-office-input.vue';

export default {
  components: {
    SearchOfficeInput,
    BaseRadio,
  },
  props: {
    value: null,
    disabled: Boolean,
    disabledOffice: Boolean,
    officeType: {
      type: String,
      default: 'stockist',
    },
  },
  emits: ['input'],
  computed: {
    officeTypeLabel() {
      return {
        stockist: 'Stockist',
        stockist_center: 'Stockist Center',
      }[this.officeType];
    },
    retur: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
